const queryOptions = (t) => [
  {
    name: 'orderId',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.orderId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'shopId',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.shopId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.createdAt'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'paymentStatus',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.paymentStatus'),
    type: 'select',
    values: ['RECEIVED', 'INITIATED', 'CONFIRMED', 'PAID', 'REJECTED', 'CANCELLED', 'REFUND', 'TIMEOUT'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.RECEIVED'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.INITIATED'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.CONFIRMED'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.PAID'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.REJECTED'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.CANCELLED'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.REFUND'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentStatusValues.TIMEOUT')
    ],
    used: false,
    value: ''
  },
  {
    name: 'paymentVendorType',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.paymentVendorType'),
    type: 'select',
    values: ['TRANSFER', 'OTP_SIMPLE', 'DEMO_OTP_SIMPLE', 'PAYPAL', 'BARION', 'MBH_QVIK'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.TRANSFER'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.OTP_SIMPLE'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.DEMO_OTP_SIMPLE'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.PAYPAL'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.BARION'),
      t('queryBuilder.queryParam.queryOptions.payment.paymentVendorTypeValues.MBH_QVIK')
    ],
    used: false,
    value: ''
  },
  {
    name: 'sort',
    displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.title'),
    type: 'key-value',
    keys: [
      { name: 'orderId', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.keys.orderId') },
      { name: 'shopId', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.keys.shopId') },
      { name: 'status', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.keys.status') },
      { name: 'createdAt', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.keys.createdAt') }
    ],
    values: [
      { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.values.asc') },
      { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.payment.sort.values.desc') }
    ],
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
